<script>
  import Animate from '@ui/pico/animate.svelte';
  import Builder from '@webforma/builder';
  import Input from '@ui/pico/input.svelte';
  import Select from '@ui/pico/select.svelte';
  import FeIcon from '../components/fe-icon.svelte';
  import { inputTypes, pages } from '../../config';
  import Accordion from '../components/accordion/index.svelte';
  import { getForm, getForms, getFormsForSite, getSite } from '../../services';
  import BreadcrumbNav from '../components/breadcrumb-nav.svelte';
  import { goto } from '../../util';
  import { account } from '../../store';

  export let params;

  let sid;
  let site;
  let forms;
  $: slc = params.slc;
  $: flc = params.flc;
  $: form = null;
  $: formDetails = `
  You are building a form for ${form?.name} (${form?.formLinkCode})
  `;

  const min = 1;
  const max = 10;
  let open = false;
  let line = 1;
  let show = true;
  let animation = 'fadeIn';
  let startVisible = false;

  function showPreventFeedback() {
    animation = 'headShake';
    startVisible = true;
    show = false;
    setTimeout(() => {
      show = true;
      startVisible = false;
    }, 100);
  }
  function inc() {
    if (line < max) {
      line++;
    } else {
      showPreventFeedback();
    }
  }
  function dec() {
    if (line > min) {
      line--;
    } else {
      showPreventFeedback();
    }
  }
  function close() {
    open = false;
  }

  let crumbs = ['Builder'];

  $: {
    if ($account) {
      init();
    }
  }

  $: prev = crumbs.slice(0, crumbs.length - 1);
  $: current = crumbs.at(-1);

  function updateRoute(ev) {
    const { sid, fid } = ev.detail;
    goto(pages.components.url, sid, fid);
  }
  async function init() {
    if ($account) {
      if (slc && !flc) {
        site = await getSite({ sid: slc });
        // TODO: this is all messed up slc should not be sid!!
        sid = slc;
        crumbs = [site?.domain, ...crumbs];
      }
      // form has the site in it so no need to query
      if (flc) {
        form = await getForm({ fid: flc });
        site = form?.site;
        sid = site?._id;
        crumbs = [
          { label: site?.domain, href: [pages.components.url, slc].join('/') },
          form?.name,
          ...crumbs,
        ];
      }
      forms = await (sid ? getFormsForSite({ sid }) : getForms());
    }
  }
</script>

<BreadcrumbNav {prev} {current} />

<header class="page-title">
  <h1>Webforma Components</h1>
</header>

{#if !open}
  <svelte:component
    this={Builder}
    on:formUpdated={updateRoute}
    fid={flc}
    sid={slc}
    {forms}
  />
{/if}

<dialog {open} class="builder">
  <div>
    <nav>
      <div>&nbsp;</div>
      <button class="outline secondary" on:click={close}>
        <FeIcon name="x" />
      </button>
    </nav>
    <div class="grid">
      <hgroup>
        <h2>Webforma Builder</h2>
        {#if !form?.name}
          <h4>Create a form in seconds</h4>
        {:else}
          <h4 data-placement="bottom" data-tooltip={formDetails}>
            {form?.name} ({form?.formLinkCode})
          </h4>
        {/if}
      </hgroup>
      <hgroup class="right">
        <h2>Editing Line {line}</h2>
        <h4>Change lines using the action buttons</h4>
      </hgroup>
    </div>
    <!-- <Builder /> -->

    <Animate name={animation} {startVisible} {show}>
      <div class="line">
        <div>
          <Select name="type" options={inputTypes} />
        </div>
        <div>
          <Input name="name" placeholder="Input Name" />
        </div>
        <div>
          <Input name="placeholder" placeholder="Placeholder" />
        </div>
        <button class="secondary outline" on:click={inc}>
          <FeIcon name="plus" />
        </button>
        <button class="secondary outline" on:click={dec}>
          <FeIcon name="minus" />
        </button>
      </div>

      <Accordion title="Attributes">
        <div class="line" slot="footer">
          <div>
            <Select name="type" options={inputTypes} />
          </div>
          <div>
            <Input name="name" placeholder="Input Name" />
          </div>
          <div>
            <Input name="placeholder" placeholder="Placeholder" />
          </div>
          <button class="secondary outline">
            <FeIcon name="plus" />
          </button>
          <button class="secondary outline">
            <FeIcon name="minus" />
          </button>
        </div>
      </Accordion>
    </Animate>
  </div>
</dialog>

<style>
  .builder > div {
    background: white;
    border-radius: 12px;
    height: 80vh;
    padding: 2rem;
    width: 90vw !important;
  }
  .builder nav {
    display: grid;
    grid-template-columns: auto 5em;
  }
  hgroup.right {
    text-align: right;
  }
  hgroup.right h2 {
    color: var(--secondary);
  }
  hgroup h2 {
    color: var(--primary);
  }
  div.line {
    display: grid;
    grid-template-columns: 1fr 1fr auto auto auto;
    gap: 1.2rem;
  }
</style>
